module.exports = __webpack_public_path__ + "img/KSC03649.8b6b0047.jpg";